<template>

	<div class="wrapper" v-on-clickaway="clickAway">
		<button class="button button-icon white" :class="{active:active}" @click="toggleActive">
			<div class="current" :style="{'background-color':handler}"></div>
		</button>

		<div class="float" v-if="active">
			<div class="presets">
				<span v-for="preset in presets" :style="{backgroundColor:preset}" @click="setPreset(preset)"></span>
			</div>
			<v-color-picker
				@input="input"
				:value="handler"
			></v-color-picker>


		</div>
	</div>


</template>

<style>
	.vc-chrome-saturation-wrap { padding-bottom:96px !important;}
	@media (max-width:991px) {
		.vc-chrome-fields-wrap { display:none !important;}
		.vc-chrome-saturation-wrap { padding-bottom:50px !important; }
		.vc-chrome-body { padding-top:12px !important; }
	}
</style>
<style scoped>
	.wrapper { }
	.button.active{position: relative;}
	.button.active:after{
		content: '';
		position: absolute;
		top: 100%;
		left: calc(50% - 5px);
		border-bottom: 7px solid white;
		border-left: 5px solid transparent;
		border-right: 5px solid transparent;
	}


	.current { width:24px; height:24px; border:1px solid #B2B2BD; border-radius: 2px;}
	.float {
		position:absolute;
		border-radius: 4px;
		padding:15px;
		z-index:4;
		background:#fff;
		width: 255px;
		box-shadow: 0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3);
	}


	.presets { display: flex; margin:0 -6px 8px; flex-wrap: wrap; }
	.presets span {
		cursor: pointer;
		height:24px;
		border:1px solid #B2B2BD;
		border-radius: 2px;
		margin: 0 2.6px 6px;
		border-radius:2px;
		width: 10.4%;
    	margin: 0 calc(1%) 6px;
	}
	.vc-chrome { box-shadow: none; margin:0 auto; }


	@media (max-width:991px) {
		.button.active:after{ display:none; }
		.float {
			position: fixed;
			width:auto;
			left:0;
			bottom:0;
		    right: 0;
			display: flex;
			align-items: center;
			padding: 10px 15px 5px;
			border-radius: 0;
		}
		.presets { margin:0; width:40%; }
		.presets span {
			width: 20.4%;
			height:22px;
			margin:0 calc(1%) 4px;
		 }
		.vc-chrome { width:60%; }
	}
	@media(min-width:992px){
		.float { top:100%; top:calc(100% + 5px);}
	}


</style>

<script>

//var Photoshop = require('vue-color/src/Photoshop.vue');

import { Chrome } from 'vue-color'

import { mixin as clickaway } from 'vue-clickaway';

export default {
	props:['value'],
	mixins: [ clickaway ],
	components:{
		VColorPicker: Chrome
	},
	data(){
		return {
			handler:'',
			active:false,
			presets:[
				'#FFFFFF', '#000000', '#CC5251', '#CC528F', '#CC52B7', '#A352CB', '#6652CD', '#527BCB',
				'#3D9CCC', '#52CCCD', '#52CB7B', '#7BCC29', '#CE7926', '#F24F18', '#CBCC28', '#57C89C',
			],
		}
	},
	methods:{
		clickAway(){
			if(!this.active) return;
			this.active = false;
			this.$emit('closeInput');
		},
		setPreset(newVal){
			this.handler = newVal;
			this.$emit('input',this.handler)
		},
		toggleActive(){
			this.active = !this.active;
			if(this.active) this.$emit('openInput');
			if(!this.active) this.$emit('closeInput');

		},
		input(newVal){

			if(newVal.a==1){
				this.handler = newVal.hex;
			} else {
				this.handler = `rgba(${newVal.rgba.r},${newVal.rgba.g},${newVal.rgba.b},${newVal.rgba.a})`;
			}
			this.$emit('input',this.handler)
		}
	},
	mounted(){
		this.handler = this.value || '#000000';
		document.body.addEventListener('keydown',(e)=>{ if(e.keyCode==27) this.clickAway(); })

	},

}
</script>
